import React from 'react';
import './styles.less';
import Images from './../../../../../constants/Images';
import ImageViewer from '../ImageViewer';
import { Spin } from 'antd';
import { omit } from 'lodash';
class Image extends React.Component {

    state = {
        loading: true,
        src: this.props.src,
        showViewer: false,
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.src !== this.props.src) {
            this.setState({ src: nextProps.src })
        }
    }

    render() {
        const { loading, src } = this.state;
        const newProps = omit(this.props, ['hasViewer', 'alt', 'wrapperStyle']);
        return (
            <div style={{ cursor: this.props.hasViewer ? 'zoom-in' : (this.props.onClick ? 'pointer' : 'default'), ...this.props.wrapperStyle }}>
                {loading && <div className="hms-image-loading"><Spin>{this.props.alt}</Spin></div>}
                <img {...newProps} src={src} alt={this.props.alt}
                    onError={this.onLoadError}
                    onLoad={this.onLoaded} onClick={this.onImageClick} />
                {this.renderViewer()}
            </div>
        )
    }

    renderViewer() {
        return (this.props.hasViewer &&
            <ImageViewer
                {...(this.props.viewerProps || {})}
                isOpen={this.state.showViewer}
                onClose={() => this.setState({ showViewer: false })}
                imgs={[{ src: this.props.src, alt: this.props.alt }]}
            />
        )
    }

    onImageClick = (e) => {
        if (this.props.hasViewer) {
            this.setState({ showViewer: true });
        } else {
            return this.props.onClick && this.props.onClick(e)
        }
    }

    onLoadError = (event) => {
        this.setState({ loading: false, src: Images.defaultImage });
    }

    onLoaded = (event) => {
        this.setState({ loading: false })
    }
}
export default Image;